export const ReportingProfileRoute = {
  REPORTINGPROFILES: 'reportingprofiles',
};

export const ReportingProfilePathName = {
  REPORTINGPROFILES: 'reportingprofiles',
  REPORTINGPROFILESFORM_NEW: 'reportingprofilesform:new',
  REPORTINGPROFILESFORM: 'reportingprofilesform',
  REPORTINGPROFILEDETAIL: 'reportingprofiledetail',
};
